import * as types from '../actions/action-types';

const initialState = {
  credits: {},
  currentSlideNumber: 1,
  folioNavigationEnabled: true,
  imageCount: 0,
  isLoading: true,
  layouts: [],
  notification: '',
  notificationIsDismissable: false,
  overview: {},
  slides: [],
  slidesEnabled: false,
  thumbs: [],
  totalImages: 0,
  totalSlides: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {

    case types.TOGGLE_FOLIO_NAVIGATION:
      return { ...state, folioNavigationEnabled: !state.folioNavigationEnabled };

    case types.SET_CURRENT_SLIDE:
      return { ...state, currentSlideNumber: action.index };

    case types.RESET_FOLIO:
      return {
        ...state,
        isLoading: true,
        slidesEnabled: false,
        slides: [],
        layouts: [],
        imageCount: 0,
        totalImages: 0,
        credits: {},
        overview: {},
        currentSlideNumber: 1,
        totalSlides: 0
      };

    case types.ENABLE_SLIDES:
      return { ...state, slidesEnabled: true };

    case types.DISABLE_SLIDES:
      return { ...state, slidesEnabled: false };

    case types.UNAUTHED_REDIRECT:
      return { ...state };

    case types.SHOW_NOTIFICATION:
      return { ...state, notification: action.notification, notificationIsDismissable: action.dismissable };

    case types.HIDE_NOTIFICATION:
      return { ...state, notification: '', notificationIsDismissable: false };

    case types.REDIRECT_TO_LOGIN:
      return { ...state };

    case types.REDIRECT_TO_ADMIN:
      return { ...state };

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/reducers/folio.js